import React, { useCallback } from 'react'
import { createState, IntegrationServiceId, ConquestPlanningEnvironment } from '../../../../common/integrations'
import { ConquestPlanningCredentialsModal } from '../ModalIntegrationConnectors/Conquest/ConquestPlanningCredentialsModal'
import { useAppSelector } from '../../../../store/hooks'
import { selectAccountId } from '../../../../store/auth/authSlice'
import { getIntegrationRedirectUri } from '../../utils'

interface ConquestPlanningIntegrationConnectorProps {
  startConnect: boolean
  onConnected: () => void
}

export const ConquestPlanningIntegrationConnector: React.FC<ConquestPlanningIntegrationConnectorProps> = ({ startConnect, onConnected }) => {
  const accountId = useAppSelector(selectAccountId)

  const handleSave = useCallback(
    ({ environment }: { environment: ConquestPlanningEnvironment }) => {
      if (!accountId) return

      const redirectUri = getIntegrationRedirectUri(IntegrationServiceId.CONQUEST_PLANNING)
      const state = createState(window.location.origin + '/dashboard/account/integration-settings/integrations', null, null, environment)

      const url = `${import.meta.env.REACT_APP_IAM_API_BASE_URL}/accounts/${accountId}/user-integrations/${IntegrationServiceId.CONQUEST_PLANNING}/enable?redirect_uri=${redirectUri}&state=${state}&environment=${environment}`
      window.location.href = url
      onConnected()
    },
    [accountId, onConnected],
  )

  return <ConquestPlanningCredentialsModal show={startConnect} onSave={handleSave} onCancel={onConnected} />
}
